module.exports = __webpack_public_path__ + "css/ecube.c262badf.css";